module.exports = __webpack_public_path__ + "img/snow-3.3b36d28a.svg";